import { msg } from '@lingui/macro';
import { IconTag } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'elabelsUpdateImport',
  status: 'active',
  category: 'other',
  icon: IconTag,
  title: msg`eLabel update`,
  shortTitle: msg`Update eLabels`,
  whenToUse: msg`Bulk-update the nutrition, ingredients and regulatory data that drive eLabel QR codes.`,
  outputDescription: msg`Updates eLabel fields (nutrition, ingredients, allergens) on your products.`,
  intents: [
    'Update eLabel nutrition',
    'Refresh ingredient lists for eLabels',
    'Bulk-update QR-code label data',
    'Add allergen info to products',
  ],
  keywords: [
    'eLabel',
    'QR',
    'nutrition',
    'ingredients',
    'allergen',
    'regulatory',
    'compliance',
    'label',
  ],
  synonyms: ['electronic label', 'EU 2021/2117', 'nutrition declaration'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: [
      'Product External ID',
      'Energy kcal',
      'Ingredients',
      'Allergens',
    ],
    requiredColumns: ['Product External ID'],
  },
};

export default descriptor;
